<template>
  <div class="dialog-warp"  >
    <div  v-loading='isLoading'>
      <el-form ref="info" size="small" label-width="120px">
        <el-row class="dialog-form">
          <el-col class="g-basic-info">
            <el-upload
              class="import-box"
              drag
              action="/patrol/importApprove/importExcel"
              :http-request="onfilechanges"
              :show-file-list="false"
              :on-success="importSuccess"
              :on-error="importError"
              :before-upload="change"

              :headers="{
                channelId: channelId,
                adminId: adminId,
                adminAccount: adminAccount,
                allSessionId: allSessionId,
              }"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text" v-html="importTip"></div>
            </el-upload>
            <!-- <ul class="error-list">
              <li v-for="(item, index) in errorList" :key="index">
                {{ item }}
              </li>
            </ul> -->
            <div class="import-tip">
              <i class="el-icon-warning-outline"></i
              >请严格按模板进行Excel清单文件编写，
              <el-button type="text" @click="download"
                >清单模板一键下载</el-button
              >
            </div>
            <div class="import-tip">
              <i class="el-icon-warning-outline"></i
              >请规范填写数据项，否则将会产生导入失败等问题
            </div>
          </el-col>
        </el-row>
      </el-form>
      <div class="text-center" style="margin-top: 20px">
        <el-button size="small" @click="close">取消</el-button>
        <el-button type="success" @click="close" size="small">确认</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import * as global from "../config/mUtils";
import * as getData from "../service/getData";
import uploadOss from "../config/oss.js";
import LoginVue from '../view/Login.vue';
export default {
  data() {
    return {
      channelId: sessionStorage.getItem("channelId"),
      adminId: sessionStorage.getItem("adminId"),
      adminAccount: sessionStorage.getItem("adminAccount"),
      allSessionId: sessionStorage.getItem("allSessionId"),
      importTip: `请将Excel清单文件拖到此区域，或<em>点击上传</em><br/>系统将识别文件内容进行自动导入`,
      importTipDefalue: `请将Excel清单文件拖到此区域，或<em>点击上传</em><br/>系统将识别文件内容进行自动导入`,
      importTipSuccess: `<div class="tit green"><i class="el-icon-success"></i>录入成功！</div>`,
      importTipError: ` <div class="tit red"><i class="el-icon-error"></i>录入异常！</div><div class="info">请检查文件是否出现错误数据或空缺数据<br/>修改完成后再次上传</div>`,
      errorList: [],
      isLoading:false,
    };
  },
  created() {},
  mounted() {},
  props: [],
  computed: {},
  methods: {
    close(type) {
      if (type === 1) {
        this.$emit("init");
      }
      this.$emit("closeDialog");
    },
    download() {
      window.open(
        "https://park-static.oss-cn-hangzhou.aliyuncs.com/%E4%BC%81%E4%B8%9A%E7%94%A8%E6%88%B7%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
      );
    },
    importSuccess(res) {
      // if (res.code === 1) {
      //   if (res.errorList.length) {
      //     this.importTip = this.importTipError;
      //     this.errorList = res.errorList;
      //   } else {
      //     this.importTip = this.importTipSuccess;
      //   }

      //   this.$emit("init");
      //   this.$message.success(res.message);
      // } else {
      //   this.$message.error(res.message);
      // }
    },
    importError() {
      // this.importTip = this.importTipError;
    },
    change() {
      // this.importTip = this.importTipDefalue;
      // this.errorList = [];
    },
    onfilechanges(params) {
      this.isLoading = true
      let formdata = new FormData();
      formdata.append("file", params.file);
      getData.importUser(formdata).then((res) => {
        this.isLoading = false
        if (res.data.code === 1) {
          this.$message.success("文件上传成功！");
          this.importTip = this.importTipSuccess;
          this.$emit("init");
        } else {
          this.importTip = `<div class="tit red"><i class="el-icon-error"></i>录入异常！</div><div class="info">${res.data.message}</div>`;
        }
      });
      return;
    },
  },
  components: {},
  watch: {},
};
</script>
<style scoped lang="scss">
@import "../assets/css/mixin";
</style>
<style lang="scss">
.g-basic-info {
  .info-item {
    border: 1px dashed #eee;
    padding: 10px;
    padding-bottom: 0;
    margin-bottom: 10px;
    &::after {
      content: "";
      zoom: 1;
      display: block;
      clear: both;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .import-box {
    width: 100%;
    .el-upload {
      width: 100%;
      .el-upload-dragger {
        width: 100%;
      }
    }
    margin-bottom: 20px;
    .tit {
      vertical-align: top;
      margin-bottom: 5px;
      &.green {
        color: rgb(9, 187, 7);
      }
      &.red {
        color: rgb(216, 30, 6);
      }
      i {
        font-size: 18px;
        margin-right: 5px;
        vertical-align: top;
      }
    }
    .info {
      color: #ccc;
      font-size: 12px;
    }
  }
  .import-tip {
    display: flex;
    align-items: center;
    margin-top: 2px;
    line-height: 1;

    i {
      color: rgb(217, 59, 10);
      font-size: 18px;
      margin-right: 5px;
    }
  }
}
.error-list {
  li {
    background-color: #eee;
    border-radius: 10px;
    padding: 10px 20px;
    color: rgb(217, 59, 10);
    margin-bottom: 5px;
  }
}

.wrong-head {
  padding: 0 10px;
  background: rgba(255, 229, 229, 1);
  width: 100%;
  height: 36px;
  line-height: 36px;
  img {
    width: 12px;
    height: 12px;
    margin-top: 12px;
  }
  span {
    font-size: 14px;
    color: rgba(241, 109, 110, 1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/meter-batch-import.vue